export default __webpack_public_path__ + "static/media/Icon_4.fab74114.png";